import React from "react";
import { Routes, Route, Link } from "react-router-dom";
import PdfToDocx from "./converters/PdfToDocx";
import DocxToPdf from "./converters/DocxToPdf";
import ImageToPdf from "./converters/ImageToPdf";
import TextToPdf from "./converters/TextToPdf";
import PdfSplitMerge from "./converters/PdfSplitMerge";

export default function DocumentConverter() {
  return (
    <div className="space-y-4">
      <h2 className="text-xl font-semibold">Document Converter</h2>
      <nav className="space-x-4">
        <Link to="pdf-to-docx" className="text-blue-600">PDF to DOCX</Link>
        <Link to="docx-to-pdf" className="text-blue-600">DOCX to PDF</Link>
        <Link to="image-to-pdf" className="text-blue-600">Image to PDF</Link>
        <Link to="text-to-pdf" className="text-blue-600">Text to PDF</Link>
        <Link to="pdf-split-merge" className="text-blue-600">Split/Merge PDF</Link>
      </nav>
      <Routes>
        <Route path="pdf-to-docx" element={<PdfToDocx />} />
        <Route path="docx-to-pdf" element={<DocxToPdf />} />
        <Route path="image-to-pdf" element={<ImageToPdf />} />
        <Route path="text-to-pdf" element={<TextToPdf />} />
        <Route path="pdf-split-merge" element={<PdfSplitMerge />} />
      </Routes>
    </div>
  );
}
